const MODULE_DEFAULT_ROUTES: Record<string, string> = {
  dashboard: "/dashboard",
  accounting: "/accounting/dashboard",
  clients: "/clients/list",
  "clients-view": "/clients/list",
  "register-list": "/clients/register-lists",
  users: "/users/list",
  roles: "/roles/list",
  "credit-score": "/credit-score",
  "credit-line-view": "/credit-line/clients/list",
  "operation-requests": "/operations/list",
  "operation-payments": "/operations/payments",
  notifications: "/notifications/list",
  enterprise: "/enterprise/list",
  rates: "/rate-history",
};

const getCurrentRoles = () => {
  const token = localStorage.getItem("token");
  if (!token) return [];

  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    const roles = payload?.roles;

    return Array.isArray(roles) ? roles : [];
  } catch {
    return [];
  }
};

export const getHomeRoute = () => {
  const roles = getCurrentRoles();

  if (roles.includes("soporte") && !roles.includes("admin")) {
    return "/clients/list";
  }

  return "/dashboard";
};

export const getDefaultRouteFromModules = () => {
  const modules = localStorage.getItem("modules")?.split(",") || [];
  const homeRoute = getHomeRoute();

  for (const module of modules) {
    if (module === "all") {
      return homeRoute;
    }

    const route = MODULE_DEFAULT_ROUTES[module];
    if (route) {
      return route;
    }
  }

  return homeRoute;
};
